export enum DataTestId {
  FOOTER = 'footer',
  HOME_PAGE = 'home-page',
  ABOUT_US_PAGE = 'about-us-page',
  AUTHORS_PAGE = 'authors-page',

  EMAIL_FIELD = 'email-field',
  PASSWORD_FIELD = 'password-field',
  PHONE_FIELD = 'phone-field',
  ERROR_MESSAGE = 'error-message',
  SMS_CONSENT = 'sms-consent',

  SUBMIT_BUTTON = 'submit-button',
  START_REGISTRATION_BUTTON = 'start-registration-button',
  CONNECT_NOW_BUTTON = 'connect-now-button',
  START_FREE_CONSULTATION_BUTTON = 'start-free-consultation-button',
  GET_STARTED_BUTTON = 'get-started-button',
  START_READING_BUTTON = 'start-reading-button',
  START_QUIZ_BUTTON = 'start-quiz-button',

  SEE_MORE_ADVISORS_BUTTON = 'see-more-advisors-button',
  FIND_ADVISOR_BUTTON = 'find-advisor-button',
  ADVISOR_WRITER_LINK = 'advisor-writer-link',
  ADVISOR_REVIEWER_LINK = 'advisor-reviewer-link',

  REJECT_PHONE_UPDATES_BUTTON = 'reject-phone-updates-button',
  ACCEPT_EMAIL_UPDATES_BUTTON = 'accept-email-updates-button',
  REJECT_EMAIL_UPDATES_BUTTON = 'reject-email-updates-button',
  THEME_SWITCH_TOGGLE = 'theme-switch-toggle',

  CONTENT_MANAGER_LINK_ERROR = 'content-manager-link-error',
  CONTENT_MANAGER_LINK_SEARCH_SUGGESTION_MENU = 'content-manager-link-search-suggestion-menu',
  CONTENT_MANAGER_BUTTON_SEARCH_SUGGESTION_MENU = 'content-manager-button-search-suggestion-menu',
  CONTENT_MANAGER_LINK_SEO = 'content-manager-link-seo',
  CONTENT_MANAGER_LINK_ADVISOR = 'content-manager-link-advisor',
  CONTENT_MANAGER_LINK_GLOSSARY_AURA = 'content-manager-link-glossary-aura',
  CONTENT_MANAGER_LINK_TAROT_SPREAD_HAND = 'content-manager-link-tarot-spread-hand',
  CONTENT_MANAGER_LINK_SUIT = 'content-manager-link-suit',
  CONTENT_MANAGER_LINK_REVIEW_MAIN = 'content-manager-link-review-main',
  CONTENT_MANAGER_LINK_SPIRITUAL = 'content-manager-link-spiritual',
  CONTENT_MANAGER_LINK_GLOSSARY_SINGLE = 'content-manager-link-glossary-single',
  CONSENT_CHECKBOX = 'consent-checkbox',

  HEADER_DRAWER_BUTTON = 'header-drawer-button',
  CONTENT_MANAGER_BANNER_LINK = 'content-manager-banner-link',
  SIGN_IN_HEADER_BUTTON = 'sign-in-header-button',
  HELP_BUTTON = 'help-fixed-button',
  MOBILE_APP_LINK = 'mobile-app-link',
  HOW_SECTION_BUTTON = 'how-section-button',
  TOPIC_LINK = 'topic-link',
  BREADCRUMB_LINK = 'breadcrumb-link',
  READ_MORE_LINK = 'read-more-link',
  CALL_TO_ACTION_BUTTON = 'call-to-action-button',

  PAGINATION_PREV_BUTTON = 'pagination-prev-button',
  PAGINATION_NEXT_BUTTON = 'pagination-next-button',
  PAGINATION_PAGE_BUTTON = 'pagination-page-button',
  PAGINATION_ELLIPSIS_BUTTON = 'pagination-ellipsis-button',
  CAROUSEL_PREV_BUTTON = 'carousel-prev-button',
  CAROUSEL_NEXT_BUTTON = 'carousel-next-button',

  START_CHAT_BUTTON = 'start-chat-button',
  CHAT_MESSAGE_FIELD = 'chat-message-field',
  SEND_MESSAGE_BUTTON = 'send-message-button',

  FREE_READING_MODAL = 'free-reading-modal',
  FREE_READING_MODAL_SUBMIT_BUTTON = 'free-reading-modal-submit-button',
  FREE_READING_MODAL_CLOSE_BUTTON = 'free-reading-modal-close-button',

  BLOG_ARTICLE_LINK = 'blog-article-link',
  BLOG_CATEGORY_LINK = 'blog-category-link',
  BROWSE_BLOG_CATEGORY_LINK = 'browse-blog-category-link',
  ARTICLE_START_SECTION = 'article-section-start',

  TAROT_SPREAD_SUMMARY = 'tarot-spread-summary',
  TAROT_SPREAD_DECK_CARD = 'tarot-spread-deck-card',
  TAROT_SPREAD_HAND_CARD = 'tarot-spread-hand-card',
  TAROT_SPREAD_HAND_FLIPPED_CARD = 'tarot-spread-hand-flipped-card',
  TAROT_CARD_LINK = 'tarot-card-link',
  CHART_LINK = 'chart-link',
  ANGEL_NUMBER_LINK = 'angel-number-link',
  SECTION_SEARCH_ANGEL_NUMBERS_TITLE = 'section-search-angel-numbers-title',
  SECTION_SEARCH_ANGEL_NUMBERS_DESCRIPTION = 'section-search-angel-numbers-description',
  SECTION_ANGEL_NUMBERS_TITLE = 'section-angel-numbers-title',
  SECTION_ANGEL_NUMBERS_LIST = 'section-angel-numbers-list',
  SECTION_START_ANGEL_NUMBERS_ITEM = 'section-start-angel-numbers-item',
  REPOSITORY_SEARCH_CONTENT = 'repository-search-content',

  REVIEWS_PLATFORM_LINK = 'reviews-platform-link',
  REVIEW_SINGLE_LINK = 'review-single-link',
  REVIEW_PREVIEW_CARD_LINK = 'review-preview-card-link',

  SEE_MORE_EXPERTS_BUTTON = 'see-more-experts-button',
  BROWSE_EXPERTS_BUTTON = 'browse-experts-button',

  SEARCH_INPUT_FIELD = 'search-input-field',
  SEARCH_SUBMIT_BUTTON = 'search-submit-button',
  SEARCH_CLEAR_BUTTON = 'search-clear-button',

  GLOSSARY_ANCHOR_LINK = 'glossary-anchor-link',
  GLOSSARY_ENTRY_LINK = 'glossary-entry-link',
  CRYSTAL_LEARN_MORE_LINK = 'crystal-learn-more-link',
  CRYSTAL_LETTER_NAV_LINK = 'crystal-letter-nav-link',

  DATE_MONTH_SELECT = 'date-month-select',
  DATE_DAY_INPUT = 'date-day-input',
  DATE_YEAR_INPUT = 'date-year-input',
  DATE_FORM_SUBMIT_BUTTON = 'date-form-submit-button',

  CONTACT_EMAIL_LINK = 'contact-email-link',
  BECOME_PSYCHIC_BUTTON = 'become-psychic-button',
  SOCIAL_LINK = 'social-link',

  ZODIAC_CARD_LINK = 'zodiac-card-link',
  ZODIAC_SIGN_LINK = 'zodiac-sign-link',

  TOOLS_SECTION_TABS = 'tools-section-tabs',
  TOOLS_SECTION_TAB = 'tools-section-tab',
  TOOLS_SECTION_TAB_PANEL = 'tools-section-tab-panel',

  BROWSE_PSYCHICS_CATEGORY_LINK = 'browse-psychics-category-link',

  TABLE_OF_CONTENT_ITEM = 'table-of-content-item',
  TABLE_OF_CONTENT_LIST = 'table-of-content-list',

  SIGN_UP_LOGIN_LINK = 'sign-up-login-link',
  SIGN_UP_SIGN_UP_LINK = 'sign-up-sign-up-link',

  EXPERT_CATALOGUE_MODAL = 'expert-catalogue-modal',
  EXPERT_CATALOGUE_MODAL_CLOSE_BUTTON = 'expert-catalogue-modal-close-button',

  SUPPORT_BOT_CHAT_BUTTON = 'support-bot-chat-button',
  SUPPORT_BOT_REFRESH_BUTTON = 'support-bot-refresh-button',
  SUPPORT_BOT_MODAL = 'support-bot-modal',
  SHOW_MORE_BUTTON = 'show-more-button',

  FAQ_ITEM = 'faq-item',
  FAQ_ITEM_TITLE = 'faq-item-title',
  FAQ_ITEM_CONTENT = 'faq-item-content',
}
